import React from 'react'
import { Panel, Container, Button, Label, Toolbar } from '@sencha/ext-modern'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetReport, doSubmitReport } from 'tyan/reducers/actions'
import TreeListView from 'tyan/components/TreeListView'
import { showFile, getFileIcon } from 'tyan/public/index'
import 'tyan/css/DetalApproval.css';

Ext.require([
	'Ext.MessageBox',
	'Ext.Toast',
])
Ext.require('Ext.MessageBox')
const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		padding: "10px",
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		padding: "10px",
		width: "100%",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
}
class ReportApprovalInfo extends React.Component {
	state = {
		report: null,
		errorMessage: null,
		reportMessage: null
	}

	componentDidMount() {
		const { doGetReport, match: { params: { reportID } } } = this.props
		doGetReport({
			reportID,
			onEnd: ({ report, errorMessage }) => {
				this.setState({ report, errorMessage })
			}
		})
	}

	handleSubmitTask = (reportID, action, comment) => {
		location.hash = `/QYWX/ReportApprovalTime/${reportID}`
	}

	handleSubmitBackTask = (reportID, action, comment) => {
		const { doSubmitReport } = this.props
		doSubmitReport({
			reportID,
			action,
			comment,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					this.setState({ errorMessage })
				} else {
					this.handleBack()
				}
			}
		})
	}

	handleBack = () => {
		const { history, match: { params: { source } } } = this.props
		Ext.toast(`执行成功！`)
		history.goBack()
	}

	showReport = report => {
		return (
			<Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
				{report && report.fields.map((item, index) => {

					switch (item.type) {
						case "attachment":
							console.log('item', item)
							return (
								<Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
									<Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
									<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
								</ Container>)
						case "tree":
							return (
								<TreeListView key={item.name} data={item.children} />)
						case "logs":
							return (
								<Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									{item.list && item.list.map((o, i) => (
										<Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
									))}
								</Container>
							)
						case "attachmentList":
							return (
								<Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									<Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
										{item.list && item.list.map((o, i) => (
											<Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
												<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
											</ Container>
										)
										)}
									</ Container>
								</Container>
							)
						default:
							return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" />)
					}
				})}
			</ Container>
		)
	}

	render() {
		const { report, errorMessage, reportMessage } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!report) {
			return <Message text="数据加载中..." />
		}

		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}

		return (
			<Panel shadow layout="vbox" {...panelProps}>
				<Container layout="vbox" flex={4} scrollable style={style.outer}>
					{this.showReport(report)}
				</Container>
				{report.statusName == '批准中' && <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
					<Button ui="action raised" text="批准" margin="5" handler={() => { this.handleSubmitTask(report.reportID, '批准中.批准', '') }} />
					<Button ui="action raised" text="退回重编" margin="5" handler={() => Ext.Msg.show({
						title: "退回确认", message: "确定要退回重编吗？",
						multiLine: true,
						buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
						fn: (buttonID, value) => buttonID == "ok" && this.handleSubmitBackTask(report.reportID, '批准中.发回重编', value)
					})} />
				</Toolbar>}
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})

export default compose(
	connect(mapStateToProps, { doGetReport, doSubmitReport })
)(ReportApprovalInfo)